import { CTableDataCell, CTableRow } from "@coreui/react";
import { useSortable } from "@dnd-kit/sortable";
import { Menu } from "@mui/icons-material";
import { CSS } from "@dnd-kit/utilities";

const SortableActivity = ({ item }) => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id: item.id });

  const styleSortableCard = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <CTableRow style={styleSortableCard} ref={setNodeRef}>
      <CTableDataCell {...attributes} {...listeners}>
        <Menu color="action" />
      </CTableDataCell>
      <CTableDataCell>{item.name}</CTableDataCell>
      <CTableDataCell>{item.type}</CTableDataCell>
      <CTableDataCell>{item.abbreviation}</CTableDataCell>
      <CTableDataCell>{item.unit}</CTableDataCell>
      <CTableDataCell>{item.defaultValue}</CTableDataCell>
      <CTableDataCell>{item.actions}</CTableDataCell>
    </CTableRow>
  );
};

export default SortableActivity;
